import { useActionsColumn } from '../../../features/table/helpers/useActionsColumn';
import { ProjectActionsBodyCell } from '../components/ProjectActionsBodyCell';

export const useProjectActionColumn = () => {
  return useActionsColumn({
    render: (text: string, row: any) => <ProjectActionsBodyCell row={row} />,
  });
};
